import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";

export interface DeleteVersionConfirmModalProps {
  /** The version awaiting confirmation, or `null` when closed. */
  target: { version: number; name: string } | null;
  onClose: () => void;
  onConfirm: (version: number) => void;
}

/**
 * Delete-a-version confirm modal. The same dialog the Publish-version action
 * opens ({@link RollbackConfirmModal}), worded like the Delete rule dialog:
 * it names what goes and says it cannot come back, because nothing can undo
 * the DELETE once it is sent.
 */
export const DeleteVersionConfirmModal = ({
  target,
  onClose,
  onConfirm,
}: DeleteVersionConfirmModalProps) => {
  let label = "";
  if (target) {
    const versionLabel = `v${target.version}`;
    label =
      target.name === `Version ${target.version}`
        ? versionLabel
        : `"${target.name}" (${versionLabel})`;
  }

  return (
    <IgDialog
      showDialog={target !== null}
      dialogContentWidth="100%"
      title="Delete version"
      handleClose={onClose}
      handleNoClick={onClose}
      handleYesClick={() => {
        if (target !== null) {
          onConfirm(target.version);
        }
      }}
      yesButtonText={target !== null ? `Delete v${target.version}` : "Delete"}
      yesButtonColor="error"
      yesButtonDisabled={target === null}
      content={
        <IgTypography variant="body2">
          {`Delete ${label}? Deleting is permanent and cannot be undone.`}
        </IgTypography>
      }
    />
  );
};
